
export const initialState = {
    whiteboard: {
        user: null,
        welcomeMessage: "Life Whiteboard",
        todo: false,
        dayPlan: true,
        friendsList: [],
        activityStream: true,
        googleSpreadsheetID: "",
        bucketList: false,
        charts: false,
        gptAdvice: false
    },
    todoList: {
        todos: [],
        todoLevel: [],
        selectedTodo: null
    },
    dayPlan: {
        events: []
    },
    bucketList: {
        buckets: [],
        calendarTodos: [],
        feelData: {}, // { bucketRowID: { date: { priority: 1-10, emotion: 'satisfied', note: 'text' } } }
        spreadsheetID: "",
        timeFrame: "Day",
        step: "Plan",
        closeOption: "Start Fresh",
        minimizeCategories: [],
        currentDate: null,
        currentTimeSlot: null,
        stepMenuOpen: false,
        timeFrameMenuOpen: false,
        closeOptionsMenuOpen: false,
        bucketViewIsOn: false,
        selectedTodo: null
    },
    mind: {
        mindMaps: {},
        currentMindMapId: null,
        lastSaved: null
    },
    mind2: {
        mindMaps: {},
        currentMindMapId: 'default',
        lastSaved: null
    }
}